module.exports = __webpack_public_path__ + "img/customDefault.6141f632.png";